import { useState, useEffect } from 'react';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';
import { ArticleListicleProps } from '../ArticleListicle/ArticleListicle';
import { api } from '@r-and-a-shared-ui/randa-trpc-client';
import { hasValue } from '@r-and-a-shared-ui/utils';

interface UseArticlesParams {
  initialArticles: ArticleListicleProps[];
  articlesIncrement: number;
  filtersToExclude: string[];
}

export const useFilteredArticles = ({
  initialArticles,
  articlesIncrement,
  filtersToExclude,
}: UseArticlesParams) => {
  const [numberofArticlesFetched, setNumberOfArticlesFetched] = useState<number>(0);
  const [loadingShowMore, setLoadingShowMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [dynamicArticleList, setDynamicArticleList] = useState<ArticleListicleProps[]>(initialArticles);
  const filters = {
    filtersToExclude: {
      pagination: {
        pageSize: articlesIncrement,
        pageNumber: pageNumber,
      },
      filtersToExclude: filtersToExclude,
    },
  };

  const { data } = api.kontent.exclusionArticles.useQuery(filters, {
    enabled: pageNumber > 0,
  });

  useEffect(() => {
    if (initialArticles) {
      setDynamicArticleList(initialArticles);
    }
  }, [initialArticles]);

  useEffect(() => {
    if (hasValue(data) && pageNumber > 0) {
      const filteredArticles: ArticleListicleProps[] =
        (data!.items?.map((x: any) => kontentAiDataMapping.article_listicle(x)) as ArticleListicleProps[]) ?? [];
      
      setNumberOfArticlesFetched(filteredArticles.length);
      setDynamicArticleList((prevState) => [...prevState, ...filteredArticles]);
      setLoadingShowMore(false);
    }
  }, [data, pageNumber]);

  const onClickShowMore = () => {
    if (loadingShowMore) return;
    setLoadingShowMore(true);
    setPageNumber((prevState) => prevState + 1);
  };

  return {
    dynamicArticleList,
    onClickShowMore,
    numberofArticlesFetched,
  };
};
